const listItemIcon = {
  styleOverrides: {
    root: {
      minWidth: 35
    },
  },
};

export default listItemIcon;
